export enum CountryCode {
    CA = "CA",
    US = "US"
}